import { ia, iaRa } from 'lib/helpers/utility';

import { patient_responsibility } from '../../lib/insuranceAdjustmentGroups';
import { amountToCents } from '../CMS1500/lib/amountToCents';

export const calculatePatientResponsibility = (procedures = [], insType = 'primary') => {
  if (!ia(procedures)) return;

  return procedures.reduce((totalResp, procedure) => {
    const insList = iaRa(procedure?.[insType]);
    if (!ia(insList)) return totalResp;

    const insListLength = insList?.length - 1 || 0;
    const lastAdj = insList[insListLength];

    const insAdj = iaRa(lastAdj?.ins_adj);
    const ptAdj = iaRa(lastAdj?.pt_adj);

    const adjustments = [...insAdj, ...ptAdj];

    const procResp = adjustments.reduce((sum, adj) => {
      const group = adj?.group;
      const code = Number(adj?.code);
      const amount = amountToCents(adj?.amount);

      const isPR = group === 'PR';
      const isPatientResponsibilityGroup =
        patient_responsibility[group] && patient_responsibility[group].includes(+code);

      if (!lastAdj?.patient_responsibility === false) {
        if (isPR && code === 45) return sum;
        if (!(isPR || isPatientResponsibilityGroup)) return sum;
      } else {
        if (!(isPR || isPatientResponsibilityGroup)) return sum;
      }

      return sum + amount;
    }, 0);

    return totalResp + procResp;
  }, 0);
};

export const getProcedureCodes = (procedures) =>
  iaRa(procedures)
    .map((p) => p.procedure_code)
    .filter(Boolean)
    .join(', ');

export const getProcedureSum = (procedures, key) =>
  iaRa(procedures)?.reduce((sum, item) => {
    if (key === 'charge') {
      const charge = Number(item?.charge) || 0;
      const units = Number(item?.units) || 1;
      return sum + charge * units;
    }

    return sum + (Number(item?.[key]) || 0);
  }, 0);
